<template>
<div>
    <div class="row">
        <div class="col-lg-3 col-md-6 col-12">
            <div class="widget style1 white-bg">
                <div class="row">
                    <div class="col-xs-4">
                        <i class="fal fa-user-check fa-5x"></i>
                    </div>
                    <div class="col-xs-8 text-right text-black-50">
                        <span class="text-md-title"> Agentes disponibles </span>
                        <h2 class="font-bold">{{agentes(['DISP']).length}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
            <div class="widget style1 white-bg">
                <div class="row">
                    <div class="col-xs-4">
                        <i class="fal fa-user-clock fa-5x"></i>
                    </div>
                    <div class="col-xs-8 text-right text-black-50">
                        <span class="text-md-title"> Agentes en pausa </span>
                        <h2 class="font-bold">{{agentes(['EPALM','EPBAÑ','EPRCON','EPINTAB','EPPTINT']).length}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
            <div class="widget style1 white-bg">
                <div class="row">
                    <div class="col-xs-4">
                        <i class="fal fa-comment-exclamation fa-5x"></i>
                    </div>
                    <div class="col-xs-8 text-right text-black-50">
                        <span class="text-md-title"> Interacciones Pendientes </span>
                        <h2 class="font-bold">{{interacciones(['Pendiente']).length}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
            <div class="widget style1 white-bg">
                <div class="row">
                    <div class="col-xs-4">
                        <i class="fal fa-comment-dots fa-5x"></i>
                    </div>
                    <div class="col-xs-8 text-right text-black-50">
                        <span class="text-md-title"> Interacciones Activas </span>
                        <h2 class="font-bold">{{interacciones(['Contestada']).length}}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-3 col-md-6 col-12">
            <div class="widget style1 white-bg">
                <div class="row">
                    <div class="col-xs-4">
                        <i class="fal fa-check fa-5x"></i>
                    </div>
                    <div class="col-xs-8 text-right text-black-50">
                        <span class="text-md-title"> Interacciones Resueltas del Dia </span>
                        <h2 class="font-bold">{{interacciones(['Finalizada']).length}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
            <div class="widget style1 white-bg">
                <div class="row">
                    <div class="col-xs-4">
                        <i class="fal fa-exchange-alt fa-5x"></i>
                    </div>
                    <div class="col-xs-8 text-right text-black-50">
                        <span class="text-md-title"> Interacciones Transferidas </span>
                        <h2 class="font-bold">{{interacciones(['Transferida']).length}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
            <div class="widget style1 white-bg">
                <div class="row">
                    <div class="col-xs-4">
                        <i class="fal fa-times fa-5x"></i>
                    </div>
                    <div class="col-xs-8 text-right text-black-50">
                        <span class="text-md-title"> Interacciones No Resueltas del día</span>
                        <h2 class="font-bold">{{interacciones(['FINALIZADA_ERROR']).length + interacciones(['Expirada']).length }}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
            <div class="widget style1 white-bg">
                <div class="row">
                    <div class="col-xs-4">
                        <i class="fal fa-flag fa-5x"></i>
                    </div>
                    <div class="col-xs-8 text-right text-black-50">
                        <span class="text-md-title"> Interacciones del día </span>
                        <h2 class="font-bold">{{interacciones(['Contestada']).length + interacciones(['Pendiente']).length + interacciones(['Finalizada']).length + interacciones(['Transferido']).length + interacciones(['Expirada']).length + interacciones(['FINALIZADA_ERROR']).length}}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    mounted() {
        // this.$store.dispatch('interacciones/obtenerInteracciones');
    },
    computed: {
        ...mapGetters({
            agentes: 'agentes/getAgentesEstados',
            interacciones: 'interacciones/getInteraccionesEstados'
        }),
    }
}
</script>
